import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Collapse from "@mui/material/Collapse";

//Components
import KogModalSideComponent from "@/main/components/modal/ModalSide";

//Services
import { getTranslateByKey } from "@/main/services/utils";

//Models
import { InvoiceFileDataResponse } from "@/main/models/response";

// Styles and local components
import ModalInvoiceQuote from "../modalInvoice/modalInvoice";
import ModalEditInvoiceQuote from "../modalEditInvoice/modalEditInvoice";
import { ModalEnum } from "@/main/services/enum/ModalEnum";

interface IControleModalInvoice {
	guidsProcurementSupplierItem: string[];
	handleModalInvoiceQuote: () => void;
	isOpenModalInvoiceQuote: boolean;
	setIsOpenModalInvoiceQuote: React.Dispatch<React.SetStateAction<boolean>>;
}

const INITIAL_STATE_INVOICE = {
	isEdit: false as boolean,
	guidInvoice: null as string | null,
	invoiceNumber: null as string | null,
	issueDate: new Date() as Date,
	supplierName: null as string | null,
	invoicesFile: [] as InvoiceFileDataResponse[],
	creationDate: new Date() as Date,
};

export interface IHandleEdit {
	isEdit: boolean;
	guid: string;
}

export type IStateInvoiceControlled = typeof INITIAL_STATE_INVOICE;

function ControleModalInvoice({
	guidsProcurementSupplierItem,
	handleModalInvoiceQuote,
	isOpenModalInvoiceQuote,
	setIsOpenModalInvoiceQuote,
}: IControleModalInvoice) {
	const [stateInvoiceControlled, setStateInvoiceControlled] = useState<IStateInvoiceControlled>(INITIAL_STATE_INVOICE);

	function handleEdit(
		isEdit: boolean,
		guid: string,
		invoiceNumber: string,
		issueDate: Date,
		supplierName: string,
		invoicesFile: InvoiceFileDataResponse[],
		creationDate: Date,
	) {
		const stateInvoice: IStateInvoiceControlled = {
			isEdit,
			guidInvoice: guid,
			invoiceNumber,
			issueDate,
			supplierName,
			invoicesFile,
			creationDate,
		};
		setStateInvoiceControlled(stateInvoice);
	}

	//#region useEffect
	useEffect(() => {
		if (!isOpenModalInvoiceQuote) {
			handleEdit(false, "", "", new Date(), "", [], new Date());
		}
	}, [isOpenModalInvoiceQuote]);
	//#endregion;

	const modalTitleReducer = ModalEnum.InvoiceManagement;
	return (
		<KogModalSideComponent
			shouldRenderOpen
			open={isOpenModalInvoiceQuote}
			title={
				stateInvoiceControlled.isEdit
					? getTranslateByKey("information.editInvoices")
					: getTranslateByKey("information.viewInvoices")
			}
			titleModalReducer={modalTitleReducer}
			closeModal={() => setIsOpenModalInvoiceQuote(false)}
		>
			{isOpenModalInvoiceQuote && (
				<>
					<Collapse in={stateInvoiceControlled.isEdit}>
						<Paper style={{ boxShadow: "none" }}>
							<ModalEditInvoiceQuote
								handleEdit={handleEdit}
								isEdit={stateInvoiceControlled.isEdit}
								guidEditInvoice={stateInvoiceControlled.guidInvoice}
								invoiceNumber={stateInvoiceControlled.invoiceNumber}
								issueDate={stateInvoiceControlled.issueDate}
								supplierName={stateInvoiceControlled.supplierName}
								invoicesFile={stateInvoiceControlled.invoicesFile}
								creationDate={stateInvoiceControlled.creationDate}
							/>
						</Paper>
					</Collapse>

					<Collapse in={!stateInvoiceControlled.isEdit}>
						<Paper style={{ boxShadow: "none" }}>
							<ModalInvoiceQuote
								isEdit={stateInvoiceControlled.isEdit}
								guidsProcurementSupplierItem={guidsProcurementSupplierItem}
								handleModalInvoiceQuote={handleModalInvoiceQuote}
								handleEdit={handleEdit}
							/>
						</Paper>
					</Collapse>
				</>
			)}
		</KogModalSideComponent>
	);
}

export default ControleModalInvoice;
